const PATH_LIST = {
    HOME: "/",
    DASHBOARD: "/dashboard",
    INCIDENT: "/incident/:incidentId",
    LOGIN: "/login",
}

export default PATH_LIST;